import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { Button, ChevronRightIcon, Link, Text } from '@beef/ui-kit';
import { BundleSwitcher } from "../../../BundleSwitcher";
import { CharacteristicsSection, ColorPickerSection, DeliveryOptionsSection, PriceSection, PromoSection, TypesOptionsSection } from "../common";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var PRICE_TITLES = {
  BUNDLE: 'Цена со скидкой за комплект',
  SALE: 'Цена со скидкой',
  SIMPLE: 'Цена за товар'
};
export var ContentPreview = function ContentPreview(_ref) {
  var _device$promoBundle3, _device$promoBundle4, _device$promoBundle5, _device$promoBundle6, _purchaseData$size, _purchaseData$variant, _device$types, _device$link;
  var device = _ref.device,
    size = _ref.size,
    isAvailableDevice = _ref.isAvailableDevice,
    purchaseData = _ref.purchaseData,
    onChangeColor = _ref.onChangeColor,
    onChangeType = _ref.onChangeType;
  var onPurchaseClick = useCallback(function (id) {
    return function () {
      if (purchaseData) {
        purchaseData.onClick(id);
      }
    };
  }, [purchaseData]);
  var isDelivery = (device === null || device === void 0 ? void 0 : device.delivery) || (device === null || device === void 0 ? void 0 : device.pickup);
  var isNewBundle = device === null || device === void 0 ? void 0 : device.isNewBundle;
  var getTitle = function getTitle() {
    var _device$promoBundle, _device$promoBundle2;
    if (device !== null && device !== void 0 && (_device$promoBundle = device.promoBundle) !== null && _device$promoBundle !== void 0 && _device$promoBundle.available && (_device$promoBundle2 = device.promoBundle) !== null && _device$promoBundle2 !== void 0 && _device$promoBundle2.isActive) return PRICE_TITLES.BUNDLE;
    if (device !== null && device !== void 0 && device.oldPrice) return PRICE_TITLES.SALE;
    return PRICE_TITLES.SIMPLE;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!(device !== null && device !== void 0 && device.promoStartSales) && /*#__PURE__*/React.createElement("div", {
    className: cn('promo-start-sales')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-l"
  }, device.promoStartSales)), /*#__PURE__*/React.createElement(PriceSection, {
    device: device,
    isAvailable: isAvailableDevice,
    size: size,
    title: isNewBundle ? getTitle() : undefined
  }), !!(device !== null && device !== void 0 && device.promoCheaper) && /*#__PURE__*/React.createElement("div", {
    className: cn('promo-cheaper')
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: device.promoCheaper.onClick,
    variant: "plain"
  }, device.promoCheaper.caption)), isNewBundle && (device === null || device === void 0 ? void 0 : (_device$promoBundle3 = device.promoBundle) === null || _device$promoBundle3 === void 0 ? void 0 : _device$promoBundle3.available) && /*#__PURE__*/React.createElement("div", {
    className: cn('bundle-switcher')
  }, /*#__PURE__*/React.createElement(BundleSwitcher, {
    isActive: (_device$promoBundle4 = device.promoBundle) === null || _device$promoBundle4 === void 0 ? void 0 : _device$promoBundle4.isActive,
    onClick: (_device$promoBundle5 = device.promoBundle) === null || _device$promoBundle5 === void 0 ? void 0 : _device$promoBundle5.onClick,
    onSwitch: (_device$promoBundle6 = device.promoBundle) === null || _device$promoBundle6 === void 0 ? void 0 : _device$promoBundle6.onSwitch
  })), purchaseData && /*#__PURE__*/React.createElement("div", {
    className: cn(size && "button-wrapper--".concat(size))
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: size !== 'xl' && size !== 'm',
    isLoading: purchaseData.isLoading,
    onClick: onPurchaseClick(device === null || device === void 0 ? void 0 : device.id),
    size: (_purchaseData$size = purchaseData.size) !== null && _purchaseData$size !== void 0 ? _purchaseData$size : 'l',
    type: "button",
    variant: (_purchaseData$variant = purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.variant) !== null && _purchaseData$variant !== void 0 ? _purchaseData$variant : 'plain'
  }, purchaseData.title)), /*#__PURE__*/React.createElement(PromoSection, {
    device: device,
    size: size
  }, device.promo), /*#__PURE__*/React.createElement(ColorPickerSection, {
    device: device,
    onChangeColor: onChangeColor,
    size: size
  }), !!(device !== null && device !== void 0 && (_device$types = device.types) !== null && _device$types !== void 0 && _device$types.length) && /*#__PURE__*/React.createElement(TypesOptionsSection, {
    onChangeType: onChangeType,
    size: size,
    types: device.types
  }), /*#__PURE__*/React.createElement(CharacteristicsSection, {
    device: device,
    size: size
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('footer', size && "footer--".concat(size))
  }, isDelivery && /*#__PURE__*/React.createElement(DeliveryOptionsSection, {
    device: device
  }), !!(device !== null && device !== void 0 && (_device$link = device.link) !== null && _device$link !== void 0 && _device$link.length) && /*#__PURE__*/React.createElement(Link, {
    href: device.link,
    isNoUnderline: true,
    rightIcon: size !== 's' ? /*#__PURE__*/React.createElement(ChevronRightIcon, null) : undefined,
    size: "size5-m",
    target: "_blank",
    variant: "dark"
  }, "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u044B\u0435 \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438")));
};